import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import Card from 'zignal-landscape/lib/Card';
import SearchInput from 'zignal-landscape/lib/SearchInput';

const HelpSearch = ({ styles }) => {
  const [query, setQuery] = React.useState(null);

  const searchHelpArticle = (baseQuery) => {
    const term = encodeURIComponent(baseQuery).replace(/%20/g, '+');
    const newQuery = `https://zignallabs.freshdesk.com/support/search/solutions?term=${term}`;
    setQuery(newQuery);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === 'Enter' && query.length >= 3) {
      window.open(query, '_blank');
    }
  };

  return (
    <div>
      <Card className={styles.HelpSearchMain}>
        <div className={styles.HomeSubTitle}>
          Search our Knowledge Base
        </div>
        <div className={styles.SearchInput}>
          <SearchInput
            placeholder="What are you looking for?"
            onChange={value => searchHelpArticle(value)}
            onKeyDown={e => handleOnKeyDown(e)}
          />
        </div>
      </Card>
    </div>
  );
};

HelpSearch.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default themeable(HelpSearch);
